import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-detailed-snackbar',
  templateUrl: './detailed-snackbar.component.html',
  styleUrls: ['./detailed-snackbar.component.scss']
})
export class DetailedSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private snackBar: MatSnackBar
  ) { }

  closeSnackbar(): void {
    this.snackBar.dismiss();
  }

  copyErrorLog(): void {
    if (this.data.errorLog) {
      navigator.clipboard.writeText(this.data.errorLog);
    }
  }

  downloadErrorLog(): void {
    if (this.data.errorLog) {
      const blob = new Blob([this.data.errorLog], { type: 'text/plain' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = this.data.downloadErrorFilename || 'error-log.txt';
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }
}
